// Species normalization map - ONLY includes aliases, NO self-mappings
// The normalizeSpecies() function already returns cleaned input if no match found
export const speciesNormalizationMap: Record<string, string> = {
  // 🐺 Canines
  wolves: "wolf",
  eastern_wolf: "eastern wolf",
  eastern_wolves: "eastern wolf",
  gray_wolf: "gray wolf",
  grey_wolf: "gray wolf",
  arctic_wolf: "arctic wolf",
  red_wolf: "red wolf",
  coyotes: "coyote",
  jackals: "jackal",
  foxes: "fox",
  arctic_fox: "arctic fox",
  fennec_fox: "fennec fox",
  fennec_foxes: "fennec fox",

  // 🐱 Felines
  lions: "lion",
  tigers: "tiger",
  bengal_tiger: "bengal tiger",
  siberian_tiger: "siberian tiger",
  cougars: "cougar",
  mountain_lion: "cougar",
  mountain_lions: "cougar",
  pumas: "cougar",
  panthers: "panther",
  leopards: "leopard",
  snow_leopard: "snow leopard",
  cheetahs: "cheetah",
  servals: "serval",
  caracals: "caracal",
  bobcats: "bobcat",
  lynxes: "lynx",

  // 🐒 Primates
  monkeys: "monkey",
  spider_monkey: "spider monkey",
  capuchins: "capuchin monkey",
  capuchin: "capuchin monkey",
  macaques: "macaque",
  marmosets: "marmoset",
  lemurs: "lemur",
  chimpanzees: "chimpanzee",
  apes: "great ape",
  gorillas: "gorilla",

  // 🐍 Reptiles
  alligators: "alligator",
  crocodiles: "crocodile",
  caimans: "caiman",
  tegus: "tegu",
  iguanas: "iguana",
  komodo_dragon: "komodo dragon",
  komodo_dragons: "komodo dragon",
  snakes: "snake",
  boa_constrictors: "boa constrictor",
  ball_pythons: "ball python",
  reticulated_pythons: "reticulated python",
  burmese_pythons: "burmese python",
  anacondas: "anaconda",

  // 🐦 Birds
  parrots: "parrot",
  african_grey: "african grey parrot",
  african_greys: "african grey parrot",
  macaws: "macaw",
  cockatoos: "cockatoo",
  hawks: "hawk",
  falcons: "falcon",
  owls: "owl",

  // 🐹 Rodents & Marsupials
  capybaras: "capybara",
  prairie_dogs: "prairie dog",
  sugar_gliders: "sugar glider",
  kangaroos: "kangaroo",
  wallabies: "wallaby",
  hedgehogs: "hedgehog",

  // 🦔 Exotics & Misc
  sloths: "sloth",
  anteaters: "anteater",
  armadillos: "armadillo",
  porcupines: "porcupine",
  raccoons: "raccoon",
  skunks: "skunk",
  meerkats: "meerkat",
  coatis: "coati",
  kinkajous: "kinkajou",
};

// Create a Set of canonical species for O(1) lookups
export const canonicalSpeciesSet = new Set(Object.values(speciesNormalizationMap));

/**
 * Normalizes species input to canonical form
 * Efficient: Only normalizes once, returns original if no mapping exists
 */
export function normalizeSpecies(input: string): string {
  if (!input) return "";
  
  // 1. Lowercase, trim, collapse whitespace, remove punctuation (except hyphens)
  const cleaned = input
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ")
    .replace(/[^\w\s-]/g, "");
  
  // 2. Check map - return canonical form if found, otherwise return cleaned input
  return speciesNormalizationMap[cleaned] ?? cleaned;
}
